// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.kKrhofchqBmMAtRFmoQA{grid-row:2;height:34px}`, "",{"version":3,"sources":["webpack://./../../../tools/nodeEditor/dist/graphSystem/display/gradientDisplayManager.module.scss"],"names":[],"mappings":"AAAA,sBACI,UAAA,CACA,WAAA","sourcesContent":[".gradientBlock {\r\n    grid-row: 2;\r\n    height: 34px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export var gradientBlock = `kKrhofchqBmMAtRFmoQA`;
export default ___CSS_LOADER_EXPORT___;
